"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlanAPI = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _axios = _interopRequireDefault(require("axios"));

var _helper = require("@/services/helper/helper.service");

var PlanAPI = /*#__PURE__*/function () {
  function PlanAPI(_ref) {
    var userSetting = _ref.userSetting,
        lfCustKey = _ref.lfCustKey,
        lfAPIToken = _ref.lfAPIToken;
    (0, _classCallCheck2.default)(this, PlanAPI);
    this.api = 'VUE_APP_API_';
    this.settings = {};
    this.lfCustKey = null;
    this.lfAPIToken = null;
    this.helper = new _helper.Helper();
    this.settings = userSetting;
    this.lfCustKey = lfCustKey;
    this.lfAPIToken = lfAPIToken;
  }

  (0, _createClass2.default)(PlanAPI, [{
    key: "assignDriver",
    value: function assignDriver(payload) {
      var url = process.env[this.api + 'LOGFLOWS_ASSIGN_DRIVER'];
      var bodyFormData = new FormData();
      bodyFormData.append('data', JSON.stringify(payload));
      var hook4 = this.helper.get(this.settings, 'hook4', '');

      if (!this.helper.isUndefined(hook4)) {
        url = hook4;
      }

      return _axios.default.request({
        'headers': {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        'method': 'POST',
        'url': "".concat(url, "?custkey=").concat(this.lfCustKey, "&token=").concat(this.lfAPIToken, "&v=1.4"),
        'data': bodyFormData
      });
    }
  }, {
    key: "cancelDriverAssignment",
    value: function cancelDriverAssignment(payload) {
      var url = process.env[this.api + 'LOGFLOWS_CANCEL_ASSIGNMENT'];
      var bodyFormData = new FormData();
      bodyFormData.append('data', JSON.stringify(payload));
      return _axios.default.request({
        'headers': {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        'method': 'POST',
        'url': "".concat(url, "?custkey=").concat(this.lfCustKey, "&token=").concat(this.lfAPIToken, "&v=1.4"),
        'data': bodyFormData
      });
    }
  }, {
    key: "printPlanId",
    value: function printPlanId(payload) {
      var url = process.env[this.api + 'LOGFLOWS_PRINT_PLAN_ID'];
      var bodyFormData = new FormData();
      bodyFormData.append('data', JSON.stringify(payload));
      return _axios.default.request({
        'headers': {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        'method': 'POST',
        'url': "".concat(url, "?custkey=").concat(this.lfCustKey, "&token=").concat(this.lfAPIToken, "&v=1.4"),
        'data': bodyFormData
      });
    }
  }]);
  return PlanAPI;
}();

exports.PlanAPI = PlanAPI;